import React, {CSSProperties, forwardRef, useId} from "react";
import ReactSelect, {GroupBase, Props as IReactSelectProps, SelectInstance} from "react-select";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useSelectTheme} from "../hooks/use_select_theme";

import {iconStyle} from "./Select.module.css";

export interface ISelectProps extends IReactSelectProps {
    isBorderless?: boolean;
    labelContent?: string;
    dataTestId?: string;
    style?: CSSProperties;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string; style?: CSSProperties}) => {
    if (props.hasLabel) {
        return (
            <div className={props.className} style={props.style}>
                {props.children}
            </div>
        );
    }
    return <>{props.children}</>;
};

function SelectBase(props: ISelectProps, ref: React.Ref<SelectInstance<unknown, boolean, GroupBase<unknown>>>) {
    const {labelContent, isBorderless, className, placeholder, dataTestId, style, styles: customStyles, ...restProps} = props;

    const {getTheme, styles} = useSelectTheme(isBorderless);

    const instanceId = useId();

    return (
        <Wrapper hasLabel={!!labelContent} className={className} style={style} data-testid={dataTestId}>
            {labelContent ? (
                <Text mb="0.4rem" variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <ReactSelect
                instanceId={instanceId}
                components={{
                    DropdownIndicator: (state) => {
                        return <ChevronDownIcon className={iconStyle} size="2" fill={`var(--colors-gray-${state.isDisabled ? "300" : "700"})`} />;
                    }
                }}
                isSearchable={false}
                theme={getTheme}
                styles={{...styles, ...customStyles}}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
                ref={ref}
            />
        </Wrapper>
    );
}

export const Select = forwardRef(SelectBase);
import React, {CSSProperties, forwardRef, useId} from "react";
import ReactSelect, {GroupBase, Props as IReactSelectProps, SelectInstance} from "react-select";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useSelectTheme} from "../hooks/use_select_theme";

import {iconStyle} from "./Select.module.css";

export interface ISelectProps extends IReactSelectProps {
    isBorderless?: boolean;
    labelContent?: string;
    dataTestId?: string;
    style?: CSSProperties;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string; style?: CSSProperties}) => {
    if (props.hasLabel) {
        return (
            <div className={props.className} style={props.style}>
                {props.children}
            </div>
        );
    }
    return <>{props.children}</>;
};

function SelectBase(props: ISelectProps, ref: React.Ref<SelectInstance<unknown, boolean, GroupBase<unknown>>>) {
    const {labelContent, isBorderless, className, placeholder, dataTestId, style, styles: customStyles, ...restProps} = props;

    const {getTheme, styles} = useSelectTheme(isBorderless);

    const instanceId = useId();

    return (
        <Wrapper hasLabel={!!labelContent} className={className} style={style} data-testid={dataTestId}>
            {labelContent ? (
                <Text mb="0.4rem" variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <ReactSelect
                instanceId={instanceId}
                components={{
                    DropdownIndicator: (state) => {
                        return <ChevronDownIcon className={iconStyle} size="2" fill={`var(--colors-gray-${state.isDisabled ? "300" : "700"})`} />;
                    }
                }}
                isSearchable={false}
                theme={getTheme}
                styles={{...styles, ...customStyles}}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
                ref={ref}
            />
        </Wrapper>
    );
}

export const Select = forwardRef(SelectBase);
